// wagmi-latest adapter — wagmi 3.x + WalletConnect v2
// Assembles the adapter record from config, provider, and hooks

import type { WalletAdapter } from '../../types.ts';
import { WagmiConnectProvider } from './provider.tsx';
import { useConnection, useSendTx } from './hooks.ts';

export const adapter: WalletAdapter = Object.freeze({
  name: 'wagmi-latest',
  Provider: WagmiConnectProvider,
  useConnection,
  useSendTx,
});
